"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var api_1 = __importDefault(require("api"));
var use_stores_1 = require("hooks/use-stores");
var PODIPCTable_1 = __importDefault(require("./PODIPCTable"));
var use_notification_1 = require("../../../../../hooks/use-notification");
var Notification_1 = require("../../../../core/Notification");
var Dialog_1 = require("../../../../core/Dialog");
var use_dialog_1 = require("../../../../../hooks/use-dialog");
var PODStage3Graphic_1 = __importDefault(require("./PODStage3Graphic"));
var PODQueryStage3 = function (_a) {
    var data = _a.data;
    var _b = react_1.useState(null), rowEditID = _b[0], setRowEditID = _b[1];
    var _c = react_1.useState(null), rowDeleteID = _c[0], setRowDeleteID = _c[1];
    var _d = react_1.useState(false), busy = _d[0], setBusy = _d[1];
    var _e = use_stores_1.useStores(), userStore = _e.userStore, queriesStore = _e.queriesStore;
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var createHandler = function (row) {
        setBusy(true);
        api_1.default.addIPCRow(data.id, row)
            .then(function (response) {
            setBusy(false);
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "IPC row successfully created"
            });
        }, function (error) {
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Failed to add IPC row"
            });
        });
    };
    var saveHandler = function (row) {
        setBusy(true);
        api_1.default.editPODIPCRow(row)
            .then(function (response) {
            setBusy(false);
            queriesStore.editDataItem(response.data);
            setRowEditID(null);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Row Successfully Saved"
            });
        }, function (error) {
            setBusy(false);
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error editing row"
            });
        });
    };
    var setEditHandler = function (id) {
        if (rowEditID !== null) {
            dialog({
                variant: Dialog_1.DialogVariants.CONFIRMATION,
                title: "Discard Changes?",
                description: "Are you sure you want to discard your current edit?"
            })
                .then(function (response) {
                setRowEditID(id);
            });
            return;
        }
        setRowEditID(id);
    };
    var deleteRowHandler = function (id) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Delete IPC Row",
            description: "Are you sure you want to delete this row?"
        })
            .then(function (response) {
            api_1.default.deletePODIPCRow(id)
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Row Successfully Deleted"
                });
                setRowDeleteID(id);
            });
        });
    };
    react_1.useEffect(function () {
        var timer = setTimeout(function () {
            queriesStore.editDataItem(__assign(__assign({}, data), { podQuery: __assign(__assign({}, data.podQuery), { podQueryIPCs: data.podQuery.podQueryIPCs.filter(function (item) { return item.id !== rowDeleteID; }) }) }));
            setRowDeleteID(null);
        }, 400);
        return function () { return clearTimeout(timer); };
    }, [rowDeleteID]);
    return (react_1.default.createElement("div", { className: "pod-query-stage-3" },
        react_1.default.createElement(PODStage3Graphic_1.default, { currentStage3: data.podQuery.currentStage3 }),
        react_1.default.createElement(PODIPCTable_1.default, { data: data.podQuery.podQueryIPCs, rowEditID: rowEditID, currentStage: data.currentStage, queryType: data.queryType.id, onCreateRow: createHandler, onSaveRow: saveHandler, onEditRow: setEditHandler, onDeleteRow: deleteRowHandler, busy: busy, currentStage3: data.podQuery.currentStage3, dummyOrder: data.podQuery.dummyOrderRequired, status: data.status })));
};
exports.default = PODQueryStage3;
